import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { injectStyles } from 'injectStyles';
import * as cssVariable from 'cssVariables';
import Button from 'components/Button';
import ButtonTypes from 'components/Button/Button.const';
import { trackJukeDownloadAppButton } from 'analytics';
import { withRouter } from 'react-router-dom';
import { isHuawei } from 'util/device';
import ContentTypeComponent from 'components/ContentTypeComponent';

class Teaser extends PureComponent {
  static defaultProps = {
    teasedStations: null,
    text: null,
    title: null,
    branchLink: null,
  };

  static propTypes = {
    branchLink: PropTypes.string,
    classes: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    teasedStations: PropTypes.object,
    text: PropTypes.string,
    title: PropTypes.string,
  };

  trackClick = (buttonName) => () => {
    trackJukeDownloadAppButton(buttonName, 'cta_click', 'click');
  };

  goToDevices = () => {
    const { history } = this.props;
    this.trackClick('Ontdek de voordelen teaser');
    history.push({ pathname: '/juke-app' });
  };

  render() {
    const { classes, title, text, branchLink, teasedStations } = this.props;

    if (isHuawei) {
      return null;
    }

    return (
      <Fragment>
        {teasedStations && (
          <div className={classes.teasedStations}>
            <ContentTypeComponent {...teasedStations} />
            <div className={classes.teasedStationsOverlay} />
          </div>
        )}
        {title && (
          <h2 data-testid="teaser-testid" className={classes.title}>
            {title}
          </h2>
        )}
        {text && <div className={classes.text} dangerouslySetInnerHTML={{ __html: text }} />}
        {branchLink && (
          <Fragment>
            <div className={classes.buttons}>
              <Button
                type={ButtonTypes.SECONDARY}
                className={classes.button}
                onClick={this.goToDevices}
                text="Ontdek de voordelen"
              />
              <Button
                type={ButtonTypes.PRIMARY}
                className={classes.button}
                text="Download JUKE-app"
                href={branchLink}
                onClick={this.trackClick('Download JUKE-app teaser')}
                rel="noopener noreferrer"
              />
            </div>
            <div className={classes.storeButtons}>
              <Button
                className={classes.storeButton}
                href={branchLink}
                onClick={this.trackClick('image googleplay')}
                rel="noopener noreferrer"
              >
                <img src={`${__URL_PREFIX__}/img/googleplay.png`} width="125" alt="Naar de play store" />
              </Button>
              <Button
                type={ButtonTypes.PRIMARY}
                className={classes.storeButton}
                href={branchLink}
                onClick={this.trackClick('image appstore')}
                rel="noopener noreferrer"
              >
                <img src={`${__URL_PREFIX__}/img/appstore.png`} width="125" alt="Naar de app store" />
              </Button>
            </div>
          </Fragment>
        )}
      </Fragment>
    );
  }
}

const styles = (theme) => ({
  teasedStations: {
    height: 80,
    paddingTop: 10,
    overflow: 'hidden',
    position: 'relative',
    pointerEvents: 'none',
  },
  teasedStationsOverlay: {
    transform: 'scale(1) perspective(1px)',
    content: '""',
    ...cssVariable.fillAspectRatio,
    top: 10,
    height: 'calc(100% - 10px)',
    zIndex: 1,
    background: 'linear-gradient(180deg, rgba(255,255,255,0.58) 0%, #FFFFFF 100%)',
  },
  title: {
    fontSize: cssVariable.fontSizes.xlarge,
    fontWeight: cssVariable.fontWeights.bold,
    textAlign: 'center',
    margin: '30px 0 0',
  },
  text: {
    fontSize: cssVariable.fontSizes.medium,
    lineHeight: '25px',
    color: theme.palette.text.primary,
    fontWeight: cssVariable.fontWeights.light,
    textAlign: 'center',
    '& > p': {
      margin: '10px 0',
    },
  },
  buttons: {
    margin: '20px -5px 0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  button: {
    flex: '1 1 0px',
    margin: '0 5px',
  },
  storeButtons: {
    padding: '0 20px',
    marginTop: 20,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  storeButton: {
    width: 125,
    padding: 0,
    border: 'none !important',
    background: 'none !important',
  },
});

export default withRouter(injectStyles(styles)(Teaser));
